export class ManufacturerType {
    id: number;
    name: string;

    constructor(
        id: number,
        name: string,
    ) {
        this.id = id;
        this.name = name;
    }

    static empty(): ManufacturerType {
        return { id: 0, name: "Machine" };
    }
}
